import { useState, useCallback } from 'react';
import { AppBar, Toolbar, Typography, Container, Box } from '@mui/material';
import LoginPage from './components/LoginPage';
import Dashboard from './components/Dashboard';
import PeerTutoring from './components/PeerTutoring/App.jsx';
import Schedule from './components/Schedule';
import Portal from './components/Portal';
import TimeTable from './components/TimeTable';
import Profile from './components/Profile';


export default function App() {
  const [loggedIn, setLoggedIn] = useState(false);
  const [classCode, setClassCode] = useState("");
  const [permission, setPermission] = useState("read");
  const [school, setSchool] = useState("shirakatsy");
  const [classes, setClasses] = useState(8);
  const [name, setName] = useState('');
  const [app, setApp] = useState(1);
  const [subjectModalOpen, setSubjectModalOpen] = useState(false);
  const initialDay = ((new Date().getDay() - 1) == 5 || (new Date().getDay() - 1) == -1) ? 0 : new Date().getDay() - 1;
  const [selectedPeriod, setSelectedPeriod] = useState(1);
  const [selectedDay, setSelectedDay] = useState(initialDay);
  const [language, setLanguage] = useState(0);

  const handleLogin = useCallback(() => {
    setLoggedIn(true);
  }, []);

  function handleSubmitModal(args) {
    if(app == 1) 
      setSelectedDay(args.day);
    if(app == 2) {
      setSelectedDay(args.day);
      setSelectedPeriod(args.period);
    }
  }

  return (
    <Box
      sx={{
        minHeight: '100vh',
        backgroundImage: `repeating-linear-gradient(
          45deg,
          #f7f9fb,
          #f7f9fb 20px,
          #eef2f6 20px,
          #eef2f6 40px
        )`,
      }}>
      <AppBar
        position="static"
        elevation={6}
        sx={{
          background: 'linear-gradient(135deg, #26b8b8, #1ea0a0)',
          borderRadius: 2,
          cursor: "pointer",
        }}
        onClick={() => setSubjectModalOpen(loggedIn)}
      >
        <Toolbar sx={{ minHeight: 72, justifyContent: 'center' }}>
          <Typography
            variant="h5"
            sx={{
              fontWeight: 500,
              letterSpacing: 1.5,
              opacity: 0.85,
            }}
          >
            {app == 0 ? language ? 'Homework' : 'Յուրացում' : app == 1 ? language ? 'Schedule' : 'Դասացուցակ' : app == 2 ? language ? 'TimeTable' : 'Ժամատախտակ' : app == 4 ? language ? 'Profile' : 'Անձնական Էջ' : 'PeerTutoring'}
          </Typography>
        </Toolbar>
      </AppBar>
      <Container sx={{ mt: 4 }}>
        {
          loggedIn
              ? (app == 0 ? <Dashboard school={school} classCode={classCode} setClassCode={setClassCode} permission={permission} language={language} setLanguage={setLanguage} /> : 
                app == 1 ? <Schedule selectedDay={selectedDay} numClassesPerDay={classes} name={name} school={school} classCode={classCode} setClassCode={setClassCode} permission={permission} language={language} /> : 
                app == 2 ? <TimeTable school={school} selectedPeriod={selectedPeriod} selectedDay={selectedDay} language={language} /> :
                app == 4 ? <Profile school={school} classCode={classCode}  name={name} permission={permission} language={language} setLanguage={setLanguage} /> :
                <PeerTutoring school={school} classCode={classCode} setClassCode={setClassCode} permission={permission} language={language} setLanguage={setLanguage} />)
              : <LoginPage setClasses={setClasses} setName={setName} school={school} setSchool={setSchool} onLogin={handleLogin} classCode={classCode} setClassCode={setClassCode} setPermission={setPermission} setLanguage={setLanguage} />
        }
      </Container>
      <Portal
        language={language}
        selectedPeriod={selectedPeriod}
        selectedDay={selectedDay}
        setApp={setApp}
        app={app}
        open={subjectModalOpen}
        onClose={() => setSubjectModalOpen(false)}
        handleSubmit={handleSubmitModal}
      />
    </Box>
  );
}
